"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TagsList = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _connectors = require("@insided/shared/services/algolia/connectors");

var _RefinedContentCheckbox = require("./RefinedContentCheckbox");

var _AccordionPanel = _interopRequireDefault(require("@insided/deprecated-control/panel/AccordionPanel"));

var _preactCompat = require("preact-compat");

var _excluded = ["title", "icon", "items"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var List = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(List, _PureComponent);

  var _super = _createSuper(List);

  function List() {
    (0, _classCallCheck2.default)(this, List);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(List, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      // Problem: In Sidebar, we want to hide this filter if there are no items.
      // Solution: We don't have the information of "number of items" in the parent (Sidebar) component, so emitting from here.
      //
      // Tried wrapping Sidebar with connectStateResults to get the number of items directly in Sidebar,
      // but turns out we cannot use connectStateResults in a component that has connectHierarchicalMenu or connectRefinementList, it results in an infinite loop.
      // Reference: https://github.com/algolia/instantsearch/issues/5269
      if (previousProps.items.length !== this.props.items.length) {
        this.props.onItemsChange(this.props.items.length);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          icon = _this$props.icon,
          items = _this$props.items,
          restProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded); // Sort items alphabetically (A→Z) by label.
      // By default, Algolia sorts by count descending which appears random to users.

      var sortedItems = (0, _toConsumableArray2.default)(items).sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });
      return (0, _preact.h)(_AccordionPanel.default, {
        panels: [{
          title: (0, _preact.h)("span", {
            className: "instant-search__filter-title"
          }, icon, title),
          body: (0, _preact.h)("div", {
            className: "instant-search__topic-type-filter"
          }, (0, _preact.h)(_RefinedContentCheckbox.RefinedContentCheckbox, (0, _extends2.default)({}, restProps, {
            items: sortedItems
          })))
        }],
        defaultActivePanelIndex: 0
      });
    }
  }]);
  return List;
}(_preactCompat.PureComponent);
/**
 * Unwrapped component for testing purposes.
 * Use this in tests to avoid dealing with lazy-loading behavior.
 * @internal
 */


exports.TagsList = List;

/**
 * Connected component wrapped with Algolia's refinement list connector.
 * Use this in production code.
 */
var _default = (0, _connectors.connectRefinementList)(List);

exports.default = _default;